import { Outlet } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

/**
 * Layout for pages that must render for a visitor with no account.
 *
 * Deliberately NOT RootLayout: that one wraps everything in ClerkProvider and
 * AuthProvider, and AuthProvider holds the whole tree behind a full-screen
 * "Loading session..." until Clerk resolves. A page built for someone who will
 * never sign in — certificate verification — would then never render at all on a
 * network that blocks Clerk, or in a build with no publishable key.
 *
 * It still needs its own QueryClientProvider: the pages here use TanStack Query
 * like the rest of the app, and without a client in scope `useQuery` throws.
 */
const publicQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // The records these pages show are immutable once issued, so there is
      // nothing to revalidate and no reason to re-hit a public endpoint.
      staleTime: Infinity,
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
});

export default function PublicLayout() {
  return (
    <QueryClientProvider client={publicQueryClient}>
      <div className="min-h-screen bg-white text-gray-900 font-sans antialiased">
        <Outlet />
      </div>
    </QueryClientProvider>
  );
}
